Alpine.data('SevenCRMCheckoutFormExpPPBtn', (element) => ({
    loading: false,

    init() {
        document.addEventListener('seven:checkout:product:selected', function(event) {
            const productId = event.detail.id;

            if (productId) {
                const url = new URL(element.href);
                url.searchParams.set('--seven_neos_crm_checkout-expresscheckoutform[product]', productId);
                element.href = url.toString();
                element.classList.remove('disabled');
            }
        });

        element.addEventListener('click', () => {
            if (!element.classList.contains('disabled')) {
                this.loading = true;
            }
        });
    }
}))